import * as React from 'react';
import SignInPage from 'src/components/referrer-portal/authentication/signin/sign-in/sign-in';
import css from 'src/components/authentication/signin/signin-container.css';
import maincss from 'src/components/authentication/main.css';


const SignInContainer = () => {
  const [creds, setCreds] = React.useState({email: '', password: ''});

  return (
    <div className={maincss.contentSideBar}>
      <div className={css.containerContent}>
        <SignInPage setCreds={setCreds} />
      </div>
    </div>
  );
};

export default SignInContainer;
